/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IEnumerableOfTransmittalDocumentFileInfoDto } from './iEnumerableOfTransmittalDocumentFileInfoDto.schema';

export const TransmittalDocumentDto = zod.object({
  "id": zod.string().uuid().optional(),
  "documentName": zod.string().optional(),
  "quantityReleased": zod.number().optional(),
  "filesReleased": zod.lazy(() => IEnumerableOfTransmittalDocumentFileInfoDto).optional(),
  "remarkReleased": zod.string().optional(),
  "quantityReceived": zod.number().optional(),
  "filesReceived": zod.lazy(() => IEnumerableOfTransmittalDocumentFileInfoDto).optional(),
  "remarkReceived": zod.string().optional()
});

export type TransmittalDocumentDto = zod.input<typeof TransmittalDocumentDto>;
export type TransmittalDocumentDtoOutput = zod.output<typeof TransmittalDocumentDto>;
